import styled from 'styled-components'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  background-color: ${({ theme }) => theme.ds.colors.neutral25};
  justify-content: start;
  padding: 10px 10px 0px -20px;
  border-radius: 8px;
  box-shadow: ${({ theme }) => theme.ds.shadows.normal};
  cursor: pointer;
  svg {
    min-width: 180px;
    min-height: 180px;
    margin-left: -20px;
  }
`

export const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
`
